<template>
    <div>
        <div class="form-single" v-if="!add">
            <div class="title">公告名称</div>
            <div class="content">
                <span>{{callBidNotice.title}}</span>
            </div>
        </div>
        <div class="form-single">
            <div class="title required">上传附件</div>
            <div class="content">
                <div class="file-area clearfix">
                    <swb-file-item v-for="(file, index) in enrollfile" :trackKey="index" :fileName="file.fileName" :fileUuid="file.fileUuid" :fileBrowseUrl="file.fileBrowseUrl" :fileDownloadUrl="file.fileDownloadUrl" :fileMd5="file.fileMd5"></swb-file-item>
                </div>
            </div>
        </div>
        <div class="form-single">
            <div class="title required">内容信息</div>
            <div class="content">
                <swb-ck-editor ref="theCkEditor" :content="callBidNotice.content" :imageXtHandler="imageXtHandler"></swb-ck-editor>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import callBidApi from '../../api/callBid'

    import SwbCkEditor from '../ctrl/CkEditor';
    Vue.regist(SwbCkEditor);

    export default {
        name: 'swb-call-bid-notice-save',
        desc: '招标公告保存',
        props: ['docId', 'id', 'add'],
        data: function () {
            let self = this;
            return {
                imageXtHandler: function (ckEditor) {
                    //
                    self.showDialogIntroImg(ckEditor);
                },
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                enrollfile: [],
                callBidNotice: {
                    content: ''
                },
                radio2: false,
                enrollCloseTime: null,
                openTime: null,
                closeTime: null,
                resultPublishTime: null,
                bizTplList: [],
                bizTplId: null,
                files: [],
            }
        },
        beforeDestroy(){
            if(this.callBidNotice != null) {
                this.callBidNotice.content = '';
            }
        },
        created: function () {

            if(!Utils.isNoB(this.id)) {
                this.getCallBidNotice();
            }
            if(this.add == false) {
                this.getBizTplList();
            }

        },
        methods: {
            getCallBidNotice: function () {
                let self = this;
                let params = {};
                params.id = self.id;
                let theLoad = MsgBox.loading();
                callBidApi.getCallBidNotice(params, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        let callBidNotice = result.data;
                        self.callBidNotice = callBidNotice;
                        let file = {};
                        file.fileBrowseUrl = callBidNotice.fileBrowseUrl;
                        file.fileDownloadUrl = callBidNotice.fileDownloadUrl;
                        file.fileExtName = callBidNotice.fileExtName;
                        file.fileName = callBidNotice.fileName;
                        file.fileMd5 = callBidNotice.fileMd5;
                        file.fileUuid = callBidNotice.fileUuid;
                        self.enrollfile.push(file);
                    }
                })
            },
            insertImageUrlsHtml: function (ckEditor, imageUrl) {

                let imageHtmlTpl = '<span><img src="{0}" /></span><br />';
                //
                var imageHtml = imageHtmlTpl.format(imageUrl);
                ckEditor.insertHtml(imageHtml + '<br/>');

            },
            showDialogIntroImg: function (ckEditor) {
                let self = this;
                let dlg = Vue.$showDialog({
                    title: "介绍相册图片",
                    width: 400,
                    height: 300,
                    showCloseBtn: true,
                    template: '<div v-loading="loading" element-loading-text="保存中...">' +
                    '<swb-file-upload fileFor="solution" fileGroup="file-misc" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone"></swb-file-upload>' +
                    '</div>',
                    data: {
                        loading: false,
                        files: [],
                    },
                    okVisible: false,
                    cancelVisible: false,
                    methods: {
                        //上传前（进行验证检查）处理，可以返回false取消上传
                        onBeforeUpload: function (fileItems, uploader) {
                            if(fileItems.length === 0) {
                                this.$alert("喂，你还没选择要上传的文件吧");
                                return false;
                            }
                        },
                        //上传进度处理
                        onProgress: function (progress) {
                            let selfDelf = this;
                            selfDelf.percentage = Math.floor((progress.loaded / progress.total) * 100);
                        },
                        //上传完毕处理（根据result.type判断是否有误）
                        onUploadDone: function (result) {
                            let selfDelf = this;
                            if(result.type === "info") {
                                let files = result.data.files;
                                // selfDelf.files =  files;
//                                console.log(files);
                                self.insertImageUrlsHtml(ckEditor, files[0].fileBrowseUrl);
                                dlg.close();
                                // return files;
                            } else {
                                selfDelf.$message.error(result.message);
                            }

                        },
                    },
                    lifecycle: {}
                });
            },
        }

    }
</script>



// WEBPACK FOOTER //
// src/compo/callbid/CallBidNoticeSave.vue